import { createGlobalStyle } from 'styled-components';

export default createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    font-size: 62.5%; /** 1rem => 10px */
  }

  body {
    background: #f2f2f2;
  }

  #root {
    min-height: 100vh;
  }

  body, input, button, textarea {
    font: 1.6rem 'Open Sans', sans-serif;
  }

  button {
    cursor: pointer;
  }

  a {
    text-decoration: none;
  }

  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    background: transparent;
  }

  ::-webkit-scrollbar-thumb {
    background-color: darkgrey;
    outline: 1px solid slategrey;
    border-radius: 10px;
  }

  @media (max-width: 600px) {
    html {
      font-size: 60%;
    }
  }
`;
